(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-coin-get-quote"]) return;
  try {
    
  	jQuery(document).ready(function() {

    	jQuery('.contactFormSelect').select2();

  		jQuery('.label_radio').on('click', function(){
  			jQuery('.options-wrapper').slideToggle('fast');
  			jQuery('.btn-upload__symbol').toggleClass('rotateSymbol');
  		})


          jQuery('#FileUpload').on('change', function(e) {
              var fileName = e.target.files[0].name;
              jQuery('.load-file-name').text(fileName);
			  jQuery('.file-name-container').show();
          });

		var input = $('.radio-container input[type="file"]');
		jQuery('.delete-file-name').on('click', function(e){
			e.preventDefault();
			var input = $('.radio-container input[type="file"]');
			input.replaceWith(input.val('').clone(true));
			jQuery('.load-file-name').text('');
			jQuery('.file-name-container').hide();
		})

	});

  } catch(e) { console.error(e); }
})();
      })();
